var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "61", height: "61", viewBox: "0 0 61 61", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "title",
      null,
      "Group 4"
    ),
    React.createElement(
      "defs",
      null,
      React.createElement("circle", { id: "b", cx: "22.5", cy: "22.5", r: "22.5" }),
      React.createElement(
        "filter",
        { x: "-30%", y: "-23.3%", width: "160%", height: "160%", filterUnits: "objectBoundingBox", id: "a" },
        React.createElement("feOffset", { dy: "3", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { stdDeviation: "4", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0.549019608 0 0 0 0 0.549019608 0 0 0 0 0.549019608 0 0 0 0.41 0", "in": "shadowBlurOuter1" })
      )
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { transform: "translate(8 5)" },
        React.createElement("use", { fill: "#000", filter: "url(#a)", xlinkHref: "#b" }),
        React.createElement("use", { fill: "#43C6AC", xlinkHref: "#b" })
      ),
      React.createElement("path", { d: "M24.77 23l5.73 5.57L36.23 23 38 24.72 30.5 32 23 24.72z", fill: "#FFF", fillRule: "nonzero" })
    )
  );
});